{
  "providers": {
    "gmail": {
      "tlds": ["com"],
      "fuzzy": 1
    },
    "hotmail": {
      "tlds": ["com", "com.br"],
      "fuzzy": 2,
      "loose": true
    },
    "outlook": {
      "tlds": ["com", "com.br"],
      "fuzzy": 2,
      "loose": true
    },
    "yahoo": {
      "tlds": ["com", "com.br"],
      "fuzzy": 1,
      "loose": true
    },
    "icloud": {
      "tlds": ["com"],
      "fuzzy": 2
    },
    "live": {
      "tlds": ["com", "com.br"],
      "loose": true
    },
    "uol": {
      "tlds": ["com.br"]
    },
    "bol": {
      "tlds": ["com.br"]
    },
    "terra": {
      "tlds": ["com.br"]
    },
    "ig": {
      "tlds": ["com.br"]
    }
  },
  "validDomains": [
    "aol.com",
    "email.com",
    "globo.com",
    "globomail.com",
    "gmx.com",
    "hotmart.com",
    "mail.com",
    "me.com",
    "msn.com",
    "proton.me",
    "protonmail.com",
    "r7.com",
    "rocketmail.com",
    "yandex.com",
    "ymail.com",
    "zipmail.com.br"
  ],
  "noFuzzLabels": [
    "aol",
    "email",
    "globo",
    "globomail",
    "gmx",
    "hotmart",
    "mail",
    "me",
    "msn",
    "proton",
    "protonmail",
    "r7",
    "rocketmail",
    "yandex",
    "ymail",
    "zipmail"
  ],
  "tldTypos": [
    "cm",
    "cm.br",
    "cmo",
    "co",
    "co.br",
    "com.b",
    "com.br.br",
    "com.brr",
    "com.bt",
    "com.nr",
    "combr",
    "comm",
    "con",
    "con.br",
    "coom",
    "cpm",
    "ocm",
    "om",
    "vom",
    "xom"
  ],
  "fixableTlds": ["com", "com.br"]
}
